require('./RAInformativeModal.scss');
// @vendor
const React = require('react');
const PropTypes = require('prop-types');

// @utilities
const { FormattedText } = require('core/i18n').i18n;

//commons
const OKModal = require('components/commons/OKModal/OKModal');

class RAInformativeModal extends React.Component {
    render() {
        const { isModalOpen, textKey, onModalClose } = this.props;
        const stringPrefix = `${textKey}-${textKey}_`;
        const title = `${stringPrefix}title`;
        const firstParagraph = `${stringPrefix}firstParagraph`;
        const secondParagraph = `${stringPrefix}secondParagraph`;
        const button = `${stringPrefix}button`;
        const modalContent = (
            <div className="ra-informative-modal__container">
                <div className="ra-informative-modal__text">
                    <FormattedText value={firstParagraph} />
                </div>
                <div className="ra-informative-modal__text">
                    <FormattedText value={secondParagraph} />
                </div>
            </div>
        );

        return (
            <OKModal
                content={modalContent}
                footerType="navigation"
                isOpen={isModalOpen}
                onCloseCallback={onModalClose}
                onPrimaryButtonClick={onModalClose}
                primaryButtonText={button}
                shouldCloseOnOverlayClick={false}
                title={title}
                titleAlignment="center"
            />
        );
    }
}

RAInformativeModal.propTypes = {
    isModalOpen: PropTypes.bool.isRequired,
    onModalClose: PropTypes.func.isRequired,
    textKey: PropTypes.string.isRequired,
};

module.exports = RAInformativeModal;
